import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material"
import { RedirectedIds } from "../../../../typing"
import { icons } from "../../../../../../utils/icons"
import { CustomTable } from "../../../../../../components"
import DownloadFiles from "../../../../../../components/donwloadFiles"
import { useTranslation } from "react-i18next"
import { createRef, useLayoutEffect, useRef, useState } from "react"
import { useStyles } from "./styles"
import { FilterHeader } from "../../components/filterHeader"
import { useInput } from "./contants"
import { dashboardService, storeServices } from "../../../../../../utils/constants/callService"
import { Item, ObjectGeneric } from "../../../../../../utils/types/generals"
import { formatTop15 } from "./methods/formatDataToEndpoint"
import { formatResponse } from "./methods/formaEndpointDataToRow"
import { formatUrlQueryFromFilters } from "./methods/formatUrlQuery"
import { FilterHeaderRef } from "../../components/filterHeader/types"
import { useNavigate } from "react-router-dom"
import { currentWeek } from "../methods/calcDates"
import { intervaleList, topQuestionnairesList } from "../../../../../../utils/constants/intervaleList"
import { getColumns, exportColumns } from "./columns"
import dayjs from "dayjs"
import { Constants } from "../../../../../../utils/constants"
import { es } from "date-fns/locale"
import { format } from "date-fns"
const defaultDates = {
  from: currentWeek().start.getTime(),
  to: currentWeek().end.getTime(),
  topQuestionnaires: topQuestionnairesList[0],
}
const Top15 = () => {
  const ref = createRef<FilterHeaderRef>()
  const navigate = useNavigate()
  const { input, items, externalValidation, removeValues } = useInput()
  const { t } = useTranslation()
  const styles = useStyles()
  const [bestStores, setBestStores] = useState<any[]>([])
  const [loadingBest, setIsLoadingBest] = useState(false)
  const [lastUpdate, setLastUpdate] = useState<{ semana: string; fecha: string }>({ semana: "", fecha: "" })
  const [unitScopeIds, setUnitScopeIds] = useState<(string | number)[]>([])
  const hasLoadedInitialData = useRef(false)

  useLayoutEffect(() => {
    const resolveUnitsScope = async () => {
      const unitsArray = Array.isArray(items.unit) ? (items.unit as Item[]) : ((items.unit as any)?.items || [])
      if (unitsArray.length) {
        setUnitScopeIds(unitsArray.map((item: Item) => item.value))
        return
      }
      try {
        const stores = await storeServices.getAllStores()
        setUnitScopeIds((stores || []).map((store: any) => store.id))
      } catch (e) {
        setUnitScopeIds([])
      }
    }
    resolveUnitsScope()
  }, [items.unit])

  const redirectToUnitDetail = ({ row }: { row?: any }) => {
    if (ref.current?.getValues) {
      const defaultValue = ref.current?.getValues()
      const unitId = row?.onlyId ? row.onlyId : (row?.unidad_id || row?.id)
      const body = formatUrlQueryFromFilters({ ...defaultValue, unit: unitId })
      navigate(`/dashboard/reports/progress-questionnaire?${body.url}`)
    }
  }

  const column: any[] = getColumns({ styles, redirectToUnitDetail })

  const handleBestStores = async (payload: ObjectGeneric, intervale: string) => {
    setIsLoadingBest(true)
    try {
      const response = await dashboardService['unitWeekRankig']({
        body: payload
      })
      const format = formatResponse({ response, values: items, intervale })
      setBestStores(format.hits)
      setLastUpdate({semana: format.hits.length ? format.hits[0]?.semana : "", fecha: format.hits.length ? format.hits[0]?.fecha : ""})
    } catch (error) {
      setBestStores([])
      setLastUpdate({ semana: "", fecha: "" })
    } finally {
      setIsLoadingBest(false)
    }
  }

  const callBestStores = (payload?: {
    dafaultValue: ObjectGeneric;
  }) => {
    const defaultValues: ObjectGeneric = payload?.dafaultValue || (ref.current?.getValues ? ref.current?.getValues() : {})
    const topQ = defaultValues?.topQuestionnaires?.value ?? defaultValues?.topQuestionnaires;
    const fixedValues = { ...defaultValues, topQuestionnaires: topQ };
    const order = topQ === 2 ? 'asc' : 'desc';
    const { body: best } = formatTop15(fixedValues, order, unitScopeIds)
    handleBestStores(best, defaultValues?.intervale?.value)

  }

  const getFilter = (payload: {
    dafaultValue: ObjectGeneric;
  }) => {
    callBestStores(payload)
  }

  const refresh = (payload: {
    dafaultValue: ObjectGeneric;
  }) => {
    callBestStores(payload)
  }

  useLayoutEffect(() => {
    if (unitScopeIds.length && !hasLoadedInitialData.current) {
      hasLoadedInitialData.current = true
      callBestStores({ dafaultValue: defaultDates })
    }
  }, [unitScopeIds])
  return (
    <Grid key={'top-15'} item xs={12}>
      <Box id={RedirectedIds.TOP_15} />

      <Box sx={styles.card}>
        <Box sx={styles.headerInputs}>
          <Box>
            <Typography sx={styles.titleHeaders}>Top de resultados</Typography>
            <Typography sx={styles.intervale}>
              {t('general.lastUpdate')}: {t('general.tags.weekYear')}: {lastUpdate.semana} - {lastUpdate.fecha ? format(
                dayjs(isNaN(Number(lastUpdate.fecha)) ? lastUpdate.fecha : Number(lastUpdate.fecha)).toDate(),
                Constants.humanFormat,
                { locale: es }
              ) : ''}
            </Typography>
          </Box>
          <Box sx={styles.icons}>
            <DownloadFiles
              row={bestStores}
              column={exportColumns}
              name="top_15_ranking"
              removeMargin={true}
              excludedWord
            />
            <FilterHeader countDefault={1} hiddenRefresh cleanFilter={removeValues} ref={ref} defaultValues={defaultDates} filterData={getFilter} refresh={refresh} title="Filtrar ranking de unidades" externalValidation={externalValidation} input={input} />
            <Tooltip title={t('ToolTips.refresh')}>
              <IconButton
                sx={styles.refresh}
                onClick={() => {
                  refresh({ dafaultValue: ref.current?.getValues ? ref.current?.getValues() : defaultDates })
                }}
              >
                {icons("refresh")}
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <Grid container spacing={3} sx={styles.tableTop}>
          <CustomTable
            loader={loadingBest}
            column={column}
            row={bestStores}
            onClick={() => { }}
            selected={-1}
            customHeaderGradient
          />
        </Grid>
      </Box>
    </Grid>
  )
}

export { Top15 }
